<template>
  <v-app>
    <v-app-bar
      app
      tile
      flat
      dark
      class="px-0 mx-0"
      height="97px"
      style="background-image: linear-gradient(to right, #02aab0, #00cdac)"
    >
      <!-- style="margin-left:-24px;    border-radius: 0px 140px 140px 0px;
	height: 120px;
	width: 400px;
  background-color:white;

      "-->
      <div
        style="
          z-index: 4;
          margin-left: -24px;
          border-bottom: 97px solid white;
          border-left: 0px solid transparent;
          border-right: 80px solid transparent;
          height: 0;
          width: 250px;
        "
      >
        <v-row
          align="center"
          justify="center"
          type="button"
          @click="
            pathname == '/home' ? $vuetify.goTo(0) : $router.push('/home')
          "
        >
          <div class="ml-10 mt-1">
            <v-img
              max-width="7%"
              style="position: relative; left: 40%; margin-top: 0%; z-index: 2"
              src="../assets/image/logo2.png"
            ></v-img>
          </div>
          <div>
            <v-img
              max-width="7%"
              style="position: relative; left: 50%; margin-top: -7%; z-index: 2"
              src="../assets/image/logo1.png"
            ></v-img>
          </div>
        </v-row>
      </div>
      <!-- <div
        
        style="position:relative; z-index:3;left:-3%;margin-top:0%; border-bottom: 97px solid #AEE6E8;
	border-left: 0px solid transparent;
	border-right: 80px solid transparent;
	height: 0;
	width: 320px;
     "
      ></div>
      <div
        style="position:relative; z-index:2;left:-5%;margin-top:0%; border-bottom: 97px solid #69CED2;
	border-left: 0px solid transparent;
	border-right: 80px solid transparent;
	height: 0;
	width: 320px;

     "
      ></div>
      <div
        style="position:relative; z-index:1;left:-8%;margin-top:0%; border-bottom: 97px solid #2FB6BC;
	border-left: 0px solid transparent;
	border-right: 80px solid transparent;
	height: 0;
	width: 320px;

     "
      ></div>-->

      <div
        style="
          z-index: 3;
          margin-left: -250px;
          border-bottom: 97px solid #aee6e8;
          border-left: 0px solid transparent;
          border-right: 80px solid transparent;
          height: 0;
          width: 320px;
        "
      ></div>
      <div
        style="
          z-index: 2;
          margin-left: -270px;
          border-bottom: 97px solid #69ced2;
          border-left: 0px solid transparent;
          border-right: 80px solid transparent;
          height: 0;
          width: 320px;
        "
      ></div>
      <div
        style="
          z-index: 1;
          margin-left: -290px;
          border-bottom: 97px solid #2fb6bc;
          border-left: 0px solid transparent;
          border-right: 80px solid transparent;
          height: 0;
          width: 320px;
        "
      ></div>

      <v-spacer></v-spacer>
      <v-btn-toggle
        v-model="text"
        dark
        tile
        group
        mandatory
        style="z-index: 4"
        :class="$vuetify.breakpoint.smOnly ? 'py-2' : 'py-2 pr-3'"
      >
        <v-btn
          class="mr-2"
          @click="$router.push('/home')"
          style="font-size: 16px"
        >
          <h4>หน้าแรก</h4>
        </v-btn>

        <v-divider class="mb-2 mr-1" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" style="font-size: 16px" v-on="on">
              <h4>เกี่ยวกับเรา</h4>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in about_us_menu"
                :key="index"
                :to="item.path"
              >
                <v-list-item-title style="line-height: 22px">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-divider class="mb-2 mr-1" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" style="font-size: 16px" v-on="on">
              <h4>บุคลากร</h4>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in personnel_menu"
                :key="index"
                :to="item.path"
              >
                <v-list-item-title style="line-height: 22px">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-divider class="mb-2 mr-1" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" style="font-size: 16px" v-on="on">
              <h4>งานบริการ</h4>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in service_menu"
                v-show="item.show"
                :key="index"
                :to="item.path"
              >
                <v-list-item-title style="line-height: 22px">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-divider class="mb-2 mr-1" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" style="font-size: 16px" v-on="on">
              <h4>งานการศึกษา</h4>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in course_menu"
                v-show="item.show"
                :key="index"
                :to="item.path"
              >
                <v-list-item-title style="line-height: 22px">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-divider class="mb-2 mr-1" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" style="font-size: 16px" v-on="on">
              <h4>หน่วยงาน</h4>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in units_menu"
                :key="index"
                :to="item.path"
              >
                <v-list-item-title style="line-height: 22px">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-divider class="mb-2 mr-1" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2" v-on="on" style="font-size: 16px">
              <h4>งานวิจัย</h4>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in research_menu"
                :key="index"
                :to="item.path"
              >
                <v-list-item-title style="line-height: 22px">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-divider class="mb-2 mr-1" inset vertical></v-divider>
        <v-menu style="z-index: 999" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-8" style="font-size: 16px" v-on="on">
              <h4>ข่าวสารและกิจกรรม</h4>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in news_menu"
                v-show="item.show"
                :key="index"
                :to="item.path"
              >
                <v-list-item-title style="line-height: 22px">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-btn-toggle>
      <!-- <v-menu
        v-model="menu"
        offset-y
        :rounded="'lg'"
        :close-on-content-click="false"
        :nudge-width="200"
        transition="slide-x-reverse-transition"
      >
      <template v-slot:activator="{ on }">-->
      <v-btn
        @click="openDialogLogin()"
        color="#ffffff"
        style="
          font-size: 16px;
          margin-top: -5px;
          background-image: linear-gradient(to right, #141e30, #243b55);
        "
        v-if="show_login"
        dark
        large
      >
        <h4>ลงชื่อเข้าใช้</h4>
      </v-btn>
      <!-- </template> -->

      <!-- </v-menu> -->
      <!-- <v-btn
          color="#ffffff"
          style="font-size:16px;margin-top:-5px;color:#1D6D7D"
          v-if="show_login"
          light
          @click="openDialogLogin()"
        >
          ลงชื่อเข้าใช้</v-btn
      >-->
      <v-menu offset-y v-if="!show_login" class="menu_home">
        <template v-slot:activator="{ on }">
          <v-btn class="mr-2" v-on="on" style="font-size: 16px" icon>
            <v-avatar size="30">
              <v-icon v-if="permission == 'user'">mdi-account</v-icon>
              <v-icon v-if="permission == 'admin'">mdi-account-edit</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list class="py-0">
          <v-list-item v-if="!show_login" style="background: #e6e6e6">
            <v-list-item-title style="line-height: 22px">{{
              this.$session.get("fullname")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item-group color="primary">
            <v-list-item
              v-if="$session.get('permission') == 'admin' && !show_login"
              @click="goPage('/register')"
            >
              <v-list-item-title style="line-height: 22px"
                >ลงทะเบียน</v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="openDialogResetPassword()">
              <v-list-item-title style="line-height: 22px" v-if="!show_login"
                >เปลี่ยนรหัสผ่าน</v-list-item-title
              >
            </v-list-item>
            <v-list-item
              v-if="$session.get('permission') == 'admin' && !show_login"
              @click="goPage('/user_management')"
            >
              <v-list-item-title style="line-height: 22px"
                >ตั้งค่าผู้ใช้งานระบบ</v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="logOut()">
              <v-list-item-title style="line-height: 22px" v-if="!show_login"
                >ออกจากระบบ</v-list-item-title
              >
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <!-- <v-btn
          color="#4AA399"
          style="font-size:16px;margin-top:-5px"
          v-if="!show_login"
          @click="logOut()"
      >ออกจากระบบ</v-btn>-->
    </v-app-bar>

    <!-- <v-content> -->
    <router-view></router-view>
    <!-- </v-content> -->

    <!-- <v-footer dark padless style="background: #1D6D7D;">
      <v-card flat tile class="white--text" style="background: #1D6D7D; padding:1% 3%;">
        <v-card-text class="white--text">
          <h3>ติดต่อเรา</h3>
          <h4
            class="py-3 my-3"
          >15 สาขาวิชาวิสัญญีวิทยา คณะแพทยาศาสตร์ มหาวิทยาลัยสงขลานครินทร์ ถ.กาญจนวนิช ต.คอหงส์ อ.หาดใหญ่ จ.สงขลา 90110</h4>
          <div>
            <span>
              <v-icon class="mr-4">mdi-phone-in-talk</v-icon>074-451651-2
            </span>
            <span class="mx-10">
              <v-icon class="mr-4">mdi-printer</v-icon>074-281656
            </span>
            <span>
              <v-icon class="mr-4">mdi-email-outline</v-icon>anespsuweb@gmail.com
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-footer>-->
    <DialogLogin ref="dialog_login" @show_login_btn="show_login"></DialogLogin>
    <DialogResetPassword ref="dialog_reset"></DialogResetPassword>
  </v-app>
</template>
<script>
import DialogLogin from "../components/DialogLogin";
import DialogResetPassword from "../components/DialogResetPassword";

export default {
  components: {
    DialogLogin,
    DialogResetPassword,
  },
  data() {
    return {
      pathname: window.location.pathname,
      username: "",
      password: "",
      //login form username: "",
      menu: false,
      password: "",
      permission: this.$session.get("permission"),
      rule_password: [(v) => !!v || "กรุณากรอกรหัสผ่าน"],
      rule_username: [(v) => !!v || "กรุณากรอกชื่อผู้ใช้"],
      // show_login: true,
      text: "",
      about_us_menu: [
        { title: "ประวัติสาขาวิชา", path: "/history" },
        {
          title: "วิสัยทัศน์ พันธกิจ และนโยบาย",
          path: "/visionandmission_general",
        },
        { title: "ทำเนียบหัวหน้าสาขาวิชา", path: "/residence" },
        { title: "โครงสร้างการบริหารสาขาวิชา", path: "/structure" },
        { title: "ทำเนียบศิษย์เก่าวิสัญญีแพทย์", path: "/alumni" },
        { title: "ทำเนียบศิษย์เก่าวิสัญญีพยาบาล", path: "/alumninurse" },
        { title: "ผู้รับบริการวิสัญญีต่อเดือน", path: "/customer" },
      ],
      personnel_menu: [
        { title: "อาจารย์วิสัญญีแพทย์", path: "/anesthesiologist" },
        { title: "วิสัญญีพยาบาล/พยาบาล", path: "/nurseanesthetist" },
        { title: "พนักงานช่วยการพยาบาล", path: "/scienceofficer" },
        {
          title: "เจ้าหน้าที่สำนักงาน",
          path: "/anesthesiologystaff",
        },
        {
          title: "แพทย์ใช้ทุน/แพทย์ประจำบ้าน/ต่อยอด",
          path: "/doctors",
        },
        { title: "พยาบาลเพิ่มพูนทักษะวิสัญญี", path: "/nurse" },
      ],
      service_menu: [
        { title: "รายงานประจำปี(งานสถิติ)", path: "/annualreport", show: true },
        { title: "ตารางปฏิบัติงาน", path: "/schedule", show: true },
        { title: "ปฏิทินกิจกรรม", path: "/activitycalendar", show: true },
        // { title: "Excellent center and sub-units", path: "/excellent" },
        {
          title: "ดาวน์โหลดเอกสาร",
          path: "/download",
          show: this.$session.get("token") ? true : false,
        },
      ],
      news_menu: [
        {
          title: "นักศึกษาแพทย์",
          path: "/medstudent?id=1",
          show: this.$session.get("token") ? true : false,
        },
        {
          title: "แพทย์ประจำบ้าน",
          path: "/doctor?id=2",
          show: this.$session.get("token") ? true : false,
        },
        {
          title: "พยาบาลเพิ่มพูนทักษะวิสัญญี",
          path: "/nursenews?id=3",
          show: this.$session.get("token") ? true : false,
        },
        { title: "กิจกรรมสาขาวิชา", path: "/newsandevent?id=4", show: true },
        { title: "ข่าวโรงพยาบาลและคณะ", path: "/hospital?id=5", show: true },
        { title: "บริการวิชาการต่อสังคม", path: "/academic?id=6", show: true },
        { title: "Morning Activity", path: "/calendarweek", show: true },
        { title: "ข่าวสารและกิจกรรมอื่นๆ", path: "/allnews", show: true },
      ],
      course_menu: [
        {
          title: "Undergraduated Diploma program",
          path: "/bachelor",
          show: true,
        },
        {
          title: "Postgraduated Diploma program",
          path: "/specializedcourses",
          show: true,
        },
        // {
        //   title: "กิจกรรมสาขาวิชา",
        //   path: "/calendarweek",
        //   show: this.$session.get("token") ? true : false,
        // },
      ],
      research_menu: [
        {
          title: "ผลงานวิจัยที่ตีพิมพ์ระดับนานาชาติ",
          path: "/International/research",
        },
        { title: "ผลงานวิจัยที่ตีพิมพ์ระดับชาติ", path: "/national/research" },
        // { title: "ผลงานวิจัยที่กำลังดำเนินการ", path: "/researching" },
        { title: "นวัตกรรมและสิ่งประดิษฐ์", path: "/invention" },
        { title: "Poster and Oral Presentation", path: "/poster" },
      ],
      units_menu: [
        { title: "Excellent Center", path: "/excellent" },
        { title: "Subunit", path: "/subunits" },
        // { title: "Cardiovascular Thoracic Anesthesia unit", path: "" },
        // { title: "Chronic Pain", path: "" },
        // { title: "Pediatric Anesthesia unit", path: "" },
        // { title: "Respiratory care unit", path: "" },
        // { title: "Intensive care unit", path: "" },
        // { title: "Regional anesthesia and Acute Pain Management unit", path: "" },
        // { title: "Neuroanesthesia unit", path: "" },
        // { title: "Trauma Anesthesia unit", path: "" },
        // { title: "Perioperative Medicine unit", path: "" },
        // { title: "Organ transplantation unit", path: "" },
        // { title: "Acute Pain Services", path: "" },
        // { title: "PSU Airway Management Excellent Center (PAMEC)", path: "" }
      ],
    };
  },
  computed: {
    show_login() {
      if (this.$session.get("token")) {
        return false;
      } else {
        return true;
      }
    },
    current_path() {
      return this.$route.fullPath;
    },
  },
  watch: {
    "$route.path"(val) {
      this.pathname = val;
      switch (val) {
        case "/home":
          this.text = 0;
          break;
        case "/history":
          this.text = 1;
          break;
        case "/visionandmission_general":
          this.text = 1;
          break;
        case "/visionandmission/research":
          this.text = 1;
          break;
        case "/visionandmission/service":
          this.text = 1;
          break;
        case "/visionandmission/academic":
          this.text = 1;
          break;
        case "/residence":
          this.text = 1;
          break;
        case "/structure":
          this.text = 1;
          break;
        case "/alumni":
          this.text = 1;
          break;
        case "/alumninurse":
          this.text = 1;
          break;
        case "/customer":
          this.text = 1;
          break;
        case "/anesthesiologist":
          this.text = 2;
          break;
        case "/nurseanesthetist":
          this.text = 2;
          break;
        case "/scienceofficer":
          this.text = 2;
          break;
        case "/anesthesiologystaff":
          this.text = 2;
          break;
        case "/doctors":
          this.text = 2;
          break;
        case "/nurse":
          this.text = 2;
          break;
        case "/annualreport":
          this.text = 3;
          break;
        case "/schedule":
          this.text = 3;
          break;
        case "/activitycalendar":
          this.text = 3;
          break;
        case "/download":
          this.text = 3;
          break;
        case "/bachelor":
          this.text = 4;
          break;
        case "/specializedcourses":
          this.text = 4;
          break;
        case "/excellent":
          this.text = 5;
          break;
        case "/subunits":
          this.text = 5;
          break;
        case "/International/research":
          this.text = 6;
          break;
        case "/national/research":
          this.text = 6;
          break;
        case "/abstract":
          this.text = 6;
          break;
        case "/invention":
          this.text = 6;
          break;
        case "/poster":
          this.text = 6;
          break;
        case "/medstudent":
          this.text = 7;
          break;
        case "/doctor":
          this.text = 7;
          break;
        case "/nursenews":
          this.text = 7;
          break;
        case "/newsandevent":
          this.text = 7;
          break;
        case "/hospital":
          this.text = 7;
          break;
        case "/academic":
          this.text = 7;
          break;
        case "/calendarweek":
          this.text = 7;
          break;
        case "/allnews":
          this.text = 7;
          break;
        case "/newsandevent_detail/detail":
          this.text = 7;
          break;
        default:
          this.text = 0;
          break;
      }
    },
  },
  created() {
    // console.log(this.$session.get("fullname"));
    // console.log(this.$route.path);
    switch (this.$route.path) {
      case "/home":
        this.text = 0;
        break;
      case "/history":
        this.text = 1;
        break;
      case "/visionandmission_general":
        this.text = 1;
        break;
      case "/visionandmission/research":
        this.text = 1;
        break;
      case "/visionandmission/service":
        this.text = 1;
        break;
      case "/visionandmission/academic":
        this.text = 1;
        break;
      case "/residence":
        this.text = 1;
        break;
      case "/structure":
        this.text = 1;
        break;
      case "/alumni":
        this.text = 1;
        break;
      case "/alumninurse":
        this.text = 1;
        break;
      case "/customer":
        this.text = 1;
        break;
      case "/anesthesiologist":
        this.text = 2;
        break;
      case "/nurseanesthetist":
        this.text = 2;
        break;
      case "/scienceofficer":
        this.text = 2;
        break;
      case "/anesthesiologystaff":
        this.text = 2;
        break;
      case "/doctors":
        this.text = 2;
        break;
      case "/nurse":
        this.text = 2;
        break;
      case "/annualreport":
        this.text = 3;
        break;
      case "/schedule":
        this.text = 3;
        break;
      case "/activitycalendar":
        this.text = 3;
        break;
      case "/download":
        this.text = 3;
        break;
      case "/bachelor":
        this.text = 4;
        break;
      case "/specializedcourses":
        this.text = 4;
        break;
      case "/excellent":
        this.text = 5;
        break;
      case "/subunits":
        this.text = 5;
        break;
      case "/International/research":
        this.text = 6;
        break;
      case "/national/research":
        this.text = 6;
        break;
      case "/abstract":
        this.text = 6;
        break;
      case "/invention":
        this.text = 6;
        break;
      case "/poster":
        this.text = 6;
        break;
      case "/medstudent":
        this.text = 7;
        break;
      case "/doctor":
        this.text = 7;
        break;
      case "/nursenews":
        this.text = 7;
        break;
      case "/newsandevent":
        this.text = 7;
        break;
      case "/hospital":
        this.text = 7;
        break;
      case "/academic":
        this.text = 7;
        break;
      case "/calendarweek":
        this.text = 7;
        break;
      case "/allnews":
        this.text = 7;
        break;
      case "/newsandevent_detail/detail":
        this.text = 7;
        break;
      default:
        this.text = 0;
        break;
    }
  },
  methods: {
    openDialogLogin() {
      this.$refs.dialog_login.open();
    },
    openDialogResetPassword() {
      this.$refs.dialog_reset.openDialogResetPassword();
    },
    // showLogin() {
    //   this.show_login = false;
    // },
    reset() {
      setTimeout(() => {
        this.$refs.loginform.reset();
        this.$refs.loginform.resetValidation();
      }, 200);
    },
    logIn() {
      // test
      // this.$session.set("token", "555");
      if (this.$refs.loginform.validate()) {
        // console.log(process.env.VUE_APP_API);
        let data = {
          username: this.username,
          password: this.password,
        };
        this.axios
          .post(process.env.VUE_APP_API + "/api/v1/login", data)
          .then((response) => {
            // console.log(response.data);

            if (response.data.message === "login success") {
              this.$session.set("token", response.data.access_token);
              this.$session.set("permission", response.data.permission);
              // this.$session.set("permission", "admin");
              this.$swal.fire("เข้าสู่ระบบสำเร็จ", "OK", "success");

              let check_token = "";
              check_token = this.$session.get("token");
              check_token != "" ? this.$emit("show_login_btn", "token") : "";
              // console.log(this.$session.getAll());
              window.location.reload();

              this.close();
            } else if (
              response.data.message === "Does not exist this username"
            ) {
              this.$swal.fire("ชื่อผู้ใช้ไม่ถูกต้อง", " ", "error");
            } else if (response.data.message === "Unauthorization") {
              this.$swal.fire("รหัสผ่านไม่ถูกต้อง", " ", "error");
            }
          });
      } else {
        // console.log("invalid");
        // this.$swal.fire("InValiD DaTa", "WarnIng", "warning");
      }
    },
    logOut() {
      this.$swal
        .fire({
          title: "ต้องการออกจากระบบใช่หรือไม่?",
          text: "จะออกจากระบบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            this.$session.clear();
            this.$router.push("/");
            window.location.reload();
          }
        });
    },
    goPage(path) {
      this.$router.push(path);
    },
    // this.$session.set("token", "");

    // this.show_login = true;
  },
};
</script>
<style>
.logo_bg {
  width: 140px;
  height: 65px;
  border-radius: 100px;
  background-color: #fdfbfb;
  margin-left: -70px;
}
</style>
